module.exports = __webpack_public_path__ + "img/contacts.fab64ebd.svg";